import(/* webpackMode: "eager" */ "/var/directorder/app/main/apps/buyer/src/app/error.js");
